import {
  TECHNICIAN_SERVICING_VERSIONS_SUCCESS
} from '../actions/technician-servicing-versions'

import merge from 'lodash/merge'

import { SERVICING_VERSIONS_SUCCESS } from '../actions/servicing-versions'

export default function (state = [], action) {
  switch (action.type) {
    case TECHNICIAN_SERVICING_VERSIONS_SUCCESS: {
      const newState = merge({}, state, action.payload.entities.technicianServicingVersions)
      return newState
    }

    case SERVICING_VERSIONS_SUCCESS: {
      return {
        ...state,
        [action.payload.technicianId]: {
          ...state[action.payload.technicianId],
          servicingVersions: {
            [action.payload.contractId]: {
              ...action.payload.entities.servicingVersions
            }
          }
        }
      }
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/technician-servicing-versions.js